"use strict";
/**
 * `Decoder` combinator: decodes `Resp` of a `Req<A>` and returns a `Req<B>`.
 *
 * @since 3.0.0
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var E = __importStar(require("fp-ts/lib/Either"));
var RE = __importStar(require("fp-ts/lib/ReaderEither"));
var RTE = __importStar(require("fp-ts/lib/ReaderTaskEither"));
var pipeable_1 = require("fp-ts/lib/pipeable");
var index_1 = require("../index");
var headers_1 = require("./headers");
/**
 * Applies `Decoder<B>` to the `Resp<A>` of a `Req` converting it to a `Resp<B>`.
 *
 * It returns a `Left<ResponseError>` in case the decoding fails.
 *
 * It automatically sets "JSON" request header's
 *
 * @since 3.0.0
 */
function withDecoder(decoder) {
    return function (req) {
        return pipeable_1.pipe(req, headers_1.withHeaders({
            Accept: 'application/json',
            'Content-type': 'application/json'
        }), RTE.chain(function (resp) {
            return RTE.fromEither(pipeable_1.pipe(parseResponse(resp), E.chain(decoder), E.bimap(function (e) { return index_1.toResponseError(e, resp.response); }, function (data) { return (__assign({}, resp, { data: data })); })));
        }));
    };
}
exports.withDecoder = withDecoder;
/**
 * Converts a `GenericDecoder<E, A>` into a `Decoder<A>`.
 *
 * @since 3.0.0
 */
function toDecoder(dec, onLeft) {
    return pipeable_1.pipe(dec, RE.mapLeft(onLeft));
}
exports.toDecoder = toDecoder;
function parseResponse(_a) {
    var data = _a.data;
    if (typeof data === 'object') {
        return E.right(data);
    }
    var asString = String(data);
    var prepared = asString.length === 0 ? '{}' : asString;
    return E.parseJSON(prepared, E.toError);
}
//# sourceMappingURL=decoder.js.map